/// <reference path="../../lib/app.d.ts" />

import {Collection} from "../lib/event-interface";
import {JoinedRoomModeSpecific} from "../chatserver/sx-server";
import logging from "../utils/log";

export enum ServerStatus {disconnected, connecting, connected}

export interface Server
{
	id : string;
	address : string;
	status ?: ServerStatus;
}

export interface H5LParams
{
	enabled : boolean;
	progressive : string;
	websocket : string;
	hls : string;
}

export interface Options
{
	servers: Array<Server>;
	h5l : H5LParams;
}

export interface ReceiverInterface
{
	evt : Collection;
	connect();
	disconnect();
	stop();
	clear();
	setVolume(amount : number);
	restoreLastStream();
	isInitialized() : boolean;
	isReady() : boolean;
	initialize($root : JQuery);
	play(...args : any[]);
	forceMute(force: boolean) : void;
	reStreamIfChanged(...args : any[]) : void;

	getCurrentName(): string;
	getVideoObject(): any;

	setFlag(flag: string, enabled : boolean): void;
}
